const CONTEXT_LABEL_ALIASES: Record<string, string[]> = {
  foto_boven: ["foto_boven", "boven"],
  foto_overzicht: ["foto_overzicht", "overzicht"],
  foto_pv_overzicht: ["foto_pv_overzicht"],
  installatie_foto: ["installatie_foto", "installatie-1", "installatie-2"],
  installatie_foto_pv: ["installatie_foto_pv"],
  constatering_foto: ["constatering_foto", "constatering"],
  constatering_herstel: ["constatering_herstel", "hersteld"],
};

export function normalizeFotoContextLabel(contextLabel: string | null | undefined): string {
  if (!contextLabel) return "";

  switch (contextLabel) {
    case "boven":
      return "foto_boven";
    case "overzicht":
      return "foto_overzicht";
    case "installatie-1":
      return "installatie_foto_1";
    case "installatie-2":
      return "installatie_foto_2";
    case "constatering":
      return "constatering_foto";
    case "hersteld":
      return "constatering_herstel";
    default:
      return contextLabel;
  }
}

export function matchesFotoContextLabel(contextLabel: string | null | undefined, expectedLabel: string): boolean {
  if (!contextLabel) return false;
  return (CONTEXT_LABEL_ALIASES[expectedLabel] ?? [expectedLabel]).includes(contextLabel);
}

export function matchesFotoContextPrefix(contextLabel: string | null | undefined, prefix: string): boolean {
  if (!contextLabel) return false;

  if (contextLabel === prefix || contextLabel.startsWith(`${prefix}_`)) {
    return true;
  }

  return (CONTEXT_LABEL_ALIASES[prefix] ?? [prefix]).includes(contextLabel);
}
